import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import config from 'config';
import { getForceLoginFlag } from 'utils/forceLoginRedirect';

const INVITE_SETUP_PATHS = [
  '/change-password',
  '/password-activation',
  '/welcome-email',
  '/register-activation',
  '/code-verify'
];

const isInviteOrPasswordSetupPath = (pathname = '') =>
  INVITE_SETUP_PATHS.some((path) => pathname.includes(path));

const GuestGuard = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const isLoaded = useSelector((state) => state.auth.isLoaded);

  useEffect(() => {
    // Do not bounce back into the app while a forced logout is in progress
    if (getForceLoginFlag()) {
      return;
    }

    // Invite / temp-password links must stay on this page even if an old
    // Amplify session still exists; otherwise GuestGuard sends them to
    // /campaigns → auth fail → /login (invite appears broken on first click).
    if (isInviteOrPasswordSetupPath(location.pathname)) {
      return;
    }

    if (isLoaded && isLoggedIn) {
      navigate(config.defaultPath, { replace: true });
    }
  }, [isLoaded, isLoggedIn, navigate, location.pathname]);

  return children;
};

export default GuestGuard;
